import AppLoader from 'Components/AppLoader';
import { mapChildProps, useUserEffect } from 'Components/Authorize/guardHelpers';
import { connect } from 'react-redux';

import { loadPage } from '../../../helpers';
import { setUserData, unsetUserData } from '../../../redux/actions';

const GuestOnlyGuard = ({
  redirectRoute,
  user,
  setUserDataAction,
  unsetUserDataAction,
  fallback,
  children,
  path,
  url,
  ...props
}) => {
  useUserEffect(setUserDataAction, unsetUserDataAction);

  if (user?.logged) {
    if (fallback) {
      return fallback;
    }
    // redirect and keep same parameters if any
    loadPage(url.replace(path, redirectRoute));
  }

  if (user?.sessionChecked) {
    return mapChildProps(children, props);
  }

  return <AppLoader />;
};

export default connect(({ user }) => ({ user }), {
  setUserDataAction: setUserData,
  unsetUserDataAction: unsetUserData,
})(GuestOnlyGuard);
